import { API } from 'aws-amplify'
let getMe = token => {
  return API.get('v1', '/v1/me', {
    headers: {
      Authorization: token,
    },
  })
}
export const userService = {
  getMe,
}
